import { render, staticRenderFns } from "./AddNewOrderZap.vue?vue&type=template&id=56b7e6b5&scoped=true&"
import script from "./AddNewOrderZap.vue?vue&type=script&lang=js&"
export * from "./AddNewOrderZap.vue?vue&type=script&lang=js&"
import style0 from "./AddNewOrderZap.vue?vue&type=style&index=0&id=56b7e6b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b7e6b5",
  null
  
)

export default component.exports